import React, { useEffect, useState } from 'react';
import Layout from 'components/Layout';
import { Box, Grid, Paper, Container, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import { Tab, Tabs, TabPanel } from 'components/UI';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@material-ui/core/styles';
import useStyles from './Authentication.styled';
import SsoTab from './tabs/ssoTab';
import MfaTab from './tabs/mfaTab';
import { useSelector } from 'react-redux';

const Authentication = () => {
  const TABS_TYPES = { MFA: 'mfa', SSO: 'sso' };
  const theme = useTheme();
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  const handleChangeIndex = (index) => setTabValue(index);
  const handleChange = (event, newValue) => setTabValue(newValue);
  const [tabs, setTabs] = useState([]);
  const settings = useSelector(
    (state) => state.config?.settings?.core?.auth?.fusion_auth_config?.settings
  );

  useEffect(() => {
    const newTabs = [];
    if (settings?.enabled === true) {
      if (settings?.sso?.enabled === true) {
        newTabs.push({ label: 'authentication.tab_title', type: TABS_TYPES.SSO });
      }
      if (settings?.mfa?.enabled === true) {
        newTabs.push({ label: 'authentication.mfa_tab.title', type: TABS_TYPES.MFA });
      }
    }
    setTabs(newTabs);
  }, [settings]);

  return (
    <Layout title={i18n.t('authentication.title')}>
      <Container className={classes.container}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              <Box fontWeight="fontWeightBold" fontSize={24} mt={2} mb={3}>
                {i18n.t('authentication.title')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3} className={classes.paper}>
              <Tabs value={tabValue} onChange={handleChange} aria-label="tab">
                {tabs.map((tab, index) => (
                  <Tab
                    key={index}
                    className={classes.tab}
                    label={i18n.t(tab.label)}
                    data-cy={tab.label}
                  />
                ))}
              </Tabs>
              <Box className={classes.tabContent}>
                <SwipeableViews index={tabValue} onChangeIndex={handleChangeIndex}>
                  {tabs.map((tab, index) => (
                    <TabPanel key={tab.type} value={tabValue} index={index} dir={theme.direction}>
                      {tab.type === TABS_TYPES.SSO && (
                        <SsoTab classes={classes} data-cy="sso-tab" />
                      )}
                      {tab.type === TABS_TYPES.MFA && (
                        <MfaTab classes={classes} data-cy="mfa-tab" />
                      )}
                    </TabPanel>
                  ))}
                </SwipeableViews>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default Authentication;
